import { createSelector } from '@reduxjs/toolkit';

import { selectOffersPerPage } from './experiments/selectOffersPerPage';
import { IAppState } from '../common/state';

const selectExtendedOffersPerPage = (state: IAppState) =>
  state.featureToggle.offersPerPageSettings.extendedOffersPerPage;

export const selectServicesBannerPositions = createSelector(
  [selectOffersPerPage, selectExtendedOffersPerPage],
  (perPage: number, extendedOffersPerPage: number): number[] => {
    /**
     * В рамках экспа делаем консистентную логику показа сервисных баннеров
     * Сервисные баннеры показываются на страницах 1-3 после 3-го объявления
     */
    if (perPage === extendedOffersPerPage) {
      return Array(3)
        .fill(1)
        .map((_, index) => index * perPage + 2);
    }

    /**
     * по умолчанию оставляем старые "нелогичные" позиции, чтобы ничего не сломать
     */
    return [2, 32, 62];
  },
);
